var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11146_5204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55556 21.0476C6.9346 18.0506 6.9346 14.9537 7.55556 11.9567C7.63715 11.6523 7.7948 11.3749 8.01299 11.1518C8.23118 10.9286 8.50241 10.7674 8.80001 10.6839C13.5675 9.87618 18.4325 9.87618 23.2 10.6839C23.4976 10.7674 23.7688 10.9286 23.987 11.1518C24.2052 11.3749 24.3629 11.6523 24.4445 11.9567C25.0654 14.9537 25.0654 18.0506 24.4445 21.0476C24.3629 21.3519 24.2052 21.6293 23.987 21.8525C23.7688 22.0756 23.4976 22.2369 23.2 22.3203C18.4325 23.1282 13.5675 23.1282 8.80001 22.3203C8.50241 22.2369 8.23118 22.0756 8.01299 21.8525C7.7948 21.6293 7.63715 21.3519 7.55556 21.0476Z",
    stroke: "#F4F6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7689 9.4395V22.5677C30.7689 27.0992 27.0953 30.7728 22.5638 30.7728H9.4356C4.90404 30.7728 1.23047 27.0992 1.23047 22.5677V9.4395C1.23047 4.90794 4.90404 1.23438 9.4356 1.23438H22.5638C27.0953 1.23438 30.7689 4.90794 30.7689 9.4395Z",
    stroke: "#F4F6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2227 19.228L18.6671 16.5007L14.2227 13.7734V19.228Z",
    stroke: "#F4F6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11146_5204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d65804a7ff2b76bf58e08c9147ec2851.svg";
export { ForwardRef as ReactComponent };